export default __webpack_public_path__ + "static/media/sold_out.f137c377.svg";